import { LayoutGrid, DoorOpen, Lock } from "lucide-react";

import { cn } from "@/lib/utils";
import { EVENTO_MODALIDAD } from "@/constants/testIds";

const OPCIONES = [
  {
    valor: "MESAS",
    titulo: "Evento con mesas",
    descripcion:
      "Los socios seleccionan una mesa y compran boletos asociados a ella.",
    Icono: LayoutGrid,
  },
  {
    valor: "ACCESO_GENERAL",
    titulo: "Acceso general",
    descripcion:
      "Los socios seleccionan uno o varios salones y la cantidad de boletos, sin elegir mesa.",
    Icono: DoorOpen,
  },
];

/**
 * Selector de modalidad del evento (Sprint 57 · F4A).
 * Presentacional: la persistencia y la guardia autoritativa viven en el
 * wizard/backend. Cuando `bloqueado` es true, el control es informativo.
 */
export default function SelectorModalidad({ value, bloqueado, onSelect }) {
  const actual = value || "MESAS";
  return (
    <section
      data-testid={EVENTO_MODALIDAD.selector}
      className="rounded-2xl border hairline bg-card p-5 flex flex-col gap-4"
    >
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <span className="overline text-accent">Modalidad del evento</span>
          <p className="text-sm text-muted-foreground mt-1">
            Define cómo comprarán los socios. Determina la configuración de los
            siguientes pasos.
          </p>
        </div>
        {bloqueado && (
          <span
            data-testid={EVENTO_MODALIDAD.bloqueado}
            className="inline-flex items-center gap-1.5 text-xs font-medium rounded-full px-2.5 py-1 bg-muted text-muted-foreground ring-1 ring-border"
          >
            <Lock className="w-3.5 h-3.5" />
            Bloqueada — el evento ya no admite cambio de modalidad
          </span>
        )}
      </div>

      <div
        role="radiogroup"
        aria-label="Modalidad del evento"
        className="grid grid-cols-1 sm:grid-cols-2 gap-3"
      >
        {OPCIONES.map(({ valor, titulo, descripcion, Icono }) => {
          const activo = actual === valor;
          return (
            <button
              key={valor}
              type="button"
              role="radio"
              aria-checked={activo}
              disabled={bloqueado}
              data-testid={EVENTO_MODALIDAD.opcion(valor)}
              data-selected={activo ? "true" : "false"}
              onClick={() => !bloqueado && onSelect(valor)}
              className={cn(
                "text-left rounded-xl border hairline p-4 transition-all flex gap-3 items-start",
                "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/60",
                activo
                  ? "border-primary/50 ring-1 ring-primary/40 bg-primary/5"
                  : "bg-background hover:border-border",
                bloqueado && !activo && "opacity-50 cursor-not-allowed",
                bloqueado && "cursor-default",
              )}
            >
              <span
                className={cn(
                  "w-9 h-9 rounded-lg grid place-items-center shrink-0 ring-1",
                  activo
                    ? "bg-primary text-primary-foreground ring-primary"
                    : "bg-muted text-muted-foreground ring-border",
                )}
              >
                <Icono className="w-4 h-4" strokeWidth={1.8} />
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <span className="font-medium text-sm">{titulo}</span>
                  {activo && (
                    <span className="text-[10px] uppercase tracking-wide text-primary font-semibold">
                      Seleccionada
                    </span>
                  )}
                </span>
                <span className="block text-xs text-muted-foreground mt-1 leading-relaxed">
                  {descripcion}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
